import { Culture } from '../../types';

export const navajo: Culture = {
  name: 'Navajo',
  languageFamily: 'Athabaskan',
  terms: [
    {
      word: 'Ashkii',
      phonetic: 'ahsh-kee',
      description: 'Navajo word for "boy."'
    },
    {
      word: 'Diné',
      phonetic: 'dih-NEH',
      description: 'The Navajo word for "the people," what the Navajo call themselves.'
    },
    {
      word: 'Hogan',
      phonetic: 'HOH-gahn',
      description: 'Traditional Navajo dwelling.'
    },
    {
      word: 'Hózhó',
      phonetic: 'hoh-zhoh',
      description: 'A central Navajo concept meaning balance, harmony, or beauty.'
    },
    {
      word: 'Nizhóní',
      phonetic: 'nih-ZHOH-nih',
      description: 'Beautiful or pretty.'
    },
    {
      word: 'Tó',
      phonetic: 'toh',
      description: 'Water.'
    },
    {
      word: 'Yá\'át\'ééh',
      phonetic: 'yah-at-eh',
      description: 'Hello, welcome, or good (can be used as a greeting).'
    }
  ]
};